import { Link, Router, useHistory, useLocation } from "react-router-dom";
import useJwtToken from "../../../config/auth/useJwtToken";
import ConvayLogo from "../../../../assets/icons/react-svg/ConvayLogo";
import {
  HomeIcon,
  MeetingIcon,
  AdminSetting,
  MenuCollapseIcon,
  HamburgerIcon,
  Cross,
  SubMenuDownArrow,
  FileIcon,
  CentralizedManagement,
  Person,
  UpgradeDiamondIcon
} from "../../../../assets/icons";
import MeetingManagementIcon from "../../../../assets/icons/react-svg/MeetingManagementIcon";
import UserManagementIcon from "../../../../assets/icons/react-svg/UserManagementIcon";
import OrgManagement from "../../../../assets/icons/react-svg/OrgManagementIcon";
import SvgRoleIcon from "../../../../assets/icons/react-svg/RoleIcon";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { getOrganizationInfo, getUserInfoById } from "../../../common/api-services/adminPanelApi";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import ChatIcon from "../../../../assets/icons/react-svg/ChatIcon";
import axios from "axios";
import { redirectToMatrix } from "../Matrix";
import { setMatrixChatVisibility, setMatrixState } from "../../../redux/slices/showMatrixChatSlice";
import Cookies from "js-cookie";
import { checkFeatureForUser } from "../../../common/utility/checkFeatureForUser";
import { USER_FEATURES } from "../../../common/utility/constants";
import { useLanguage } from "../../../../context/LanguageContext";
import styles from "./Sidebar.module.css";
import { div } from "@tensorflow/tfjs-core";
import { RoleType } from "../../../types/enums/RoleTypeEnum";
import { appUrls } from "../../../config/api-config/appUrls";
import { environment } from "../../../config/environments/environment";
import SidebarFeedbackModal from "./SidebarFeedbackModal";
import {
  getCurrentUserPlan,
  getPlanSearchByName,
} from "../../../common/api-services/organizationApi";
import { isMobile } from "react-device-detect";
import { useBranding } from "../../../theme/BrandingProvider";
function parsePlanNameFromUserPlanResponse(res: any): string | null {
  const d = res?.data;
  if (d == null) return null;
  if (typeof d === "string" && d.trim()) return d.trim();
  const name = d.planName;
  return typeof name === "string" && name.trim() ? name.trim() : null;
}

function parseMeetingLengthMinutesFromPlanSearchResponse(res: any): number | null {
  const d = res?.data;
  const plan = Array.isArray(d) ? d[0] : d;
  if (!plan || typeof plan !== "object") return null;
  const raw = plan.maxMeetingLength;
  const num =
    typeof raw === "number"
      ? raw
      : typeof raw === "string"
        ? parseFloat(raw.trim())
        : NaN;
  if (!Number.isFinite(num) || num <= 0) return null;
  return Math.round(num * 60);
}
function formatHoursForDisplay(totalMinutes: number): string {
  const h = totalMinutes / 60;
  if (Number.isInteger(h)) return String(h);
  return String(Math.round(h * 10) / 10);
}
function getOwnerUpgradeCardMeta(
  t: (key: string, opts?: Record<string, unknown>) => string,
  minutes: number | null,
  isFreePlan: boolean,
  isProPlan: boolean,
  isEduPlan: boolean,
): string | null {
  if (isEduPlan) {
    return t("upgrade_card_edu_owner_text");
  }
  if (isFreePlan) {
    return (minutes!==null && minutes > 60
      ? t("upgrade_card_meeting_duration_hours", {
          hours: formatHoursForDisplay(minutes),
        })
      : t("upgrade_card_meeting_duration_minutes", {
          minutes: minutes,
        }))
  }
  if (isProPlan) {
    return t("upgrade_card_pro_owner_text");
  } 
  return t("upgrade_card_business_owner_text");
}
function getUserUpgradeCardMeta(
  t: (key: string, opts?: Record<string, unknown>) => string,
  minutes: number | null,
  isFreePlan: boolean,
  isProPlan: boolean,
  isEduPlan: boolean,
): string | null {
  if (isProPlan) {
    return t("upgrade_card_pro_user_text");
  }
  if (isFreePlan) {
    return t("upgrade_card_free_user_text");
  }
  if (isEduPlan) {
    return t("upgrade_card_edu_user_text");
  } 
  return t("upgrade_card_business_user_text");
}
const FREE_PLAN_MEETING_DURATION_FALLBACK_MINUTES = 55;

export default function sidebar() {


  const { t } = useLanguage();
    const activeCalls = useSelector((state: RootState) => state.activeCalls.activeCalls);

  const [isCollapse, setIsCollapse] = useState(false);
  const [hasSubMenu, setHasSubMenu] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const dispatch = useDispatch();
  const showMatrix = useSelector((state: RootState) => state.matrix.showMatrix);
  const authUser = useJwtToken();
  const [organizationLogo, setOrganizationLogo] = useState<any>();
  const [organizationName, setOrganizationName] = useState<any>();
  const [firstOrgWord, setFirstOrgWord] = useState<any>();
  const [secondOrgWord, setSecondOrgWord] = useState<any>();
  const orgInfo = useSelector((state: RootState) => state.organization.orgInfo);
  const [chatClass, setChatClass] = useState(false);
  const loc = useLocation();
  const authToken: string | undefined = Cookies.get("auth_token");
  const history = useHistory();
  // Branding is fetched once by BrandingProvider, above the router, so it also covers the guest
  // screens this component never renders on.
  const orgAppearance = useBranding();

  const [hasCmAccess, setHasCmAccess] = useState(false);
  const [hasDriveAccess, setHasDriveAccess] = useState(false);
  const [hasChatAccess, setHasChatAccess] = useState(false);
  const [role, setRole] = useState<RoleType>(RoleType.User);
  const [planLabel, setPlanLabel] = useState<string>("");
  const [meetingDurationMinutes, setMeetingDurationMinutes] = useState<number | null>(null);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const _allowInPersonMeeting = environment?.allowInPersonMeeting
  const appName = String(environment.appName)

  useEffect(() => {
    getUserInfoById(authUser?.user?.ID).then((res: any) => {
      setRole(res?.data?.role?.roleName);
    });
  }, []);

  useEffect(() => {
    checkChatAvailability()
  }, [])
  const checkChatAvailability = async () => {

    const isAvailable = await checkFeatureForUser(USER_FEATURES.CHAT);
    if (isAvailable) {
      dispatch(setMatrixChatVisibility(true))
    }
  }

  function setIsCollapseChange() {
    setIsCollapse(!isCollapse);
  }

  function setHasSubMenuChange() {
    setHasSubMenu(!hasSubMenu);
  }

  function setMobileMenuChange() {
    setMobileMenu(!mobileMenu);
  }

  const shouldDisplayMatrixChat = useSelector(
    (state: RootState) => state.matrix.isChatVisible
  );

  const authObject = useJwtToken()

  function setActiveClass(val: string) {
    if (!chatClass) {
      if (val === "home") {
        if (!showMatrix) {
          return "cnv-active";
        } else if (showMatrix) {
          return "";
        }
      } else {
        if (val === loc.pathname) {
          return "cnv-active";
        } else {
          return "";
        }
      }
    }
    return "";
  }

  useMemo(() => showMatrix && setChatClass(true), [showMatrix]);

  useEffect(() => {
    /*
     * get all information of an organization
     */
    getOrganizationInfo(authUser?.user.organization_id).then((res: any) => {
      setOrganizationName(res.data.org_name);
      let str = res.data.org_name;
      str = str.replace(/(^\s*)|(\s*$)/gi, "");
      str = str.replace(/[ ]{2,}/gi, " ");
      str = str.replace(/\n /, "\n");
      let length = str.split(" ").length;
      let firstWordOrg = res.data.org_name.split(" ").slice(0, 1).join("");
      if (firstWordOrg) {
        setFirstOrgWord(firstWordOrg[0].toUpperCase());
      }
      if (length > 1) {
        let secondWordOrg = res.data.org_name.split(" ").slice(1, 2).join("");
        setSecondOrgWord(secondWordOrg[0].toUpperCase());
      }
      setOrganizationLogo(res.data.org_logo);
    });
  }, [orgInfo]);

  // Font loading and brand colour now live in src/app/theme/applyBrand.ts, applied to the
  // document root so the whole application picks them up rather than this component alone.

  const updateFavicon = (faviconUrl: string | null) => {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
    }
    const faviconLink = link as HTMLLinkElement;

    faviconLink.type = 'image/x-icon';
    faviconLink.rel = 'shortcut icon';
    faviconLink.href = faviconUrl
      ? `${environment.fileServiceApi}file/${faviconUrl}`
      : '/favicon.ico';

    document.head.appendChild(faviconLink);
  };

  useEffect(() => {
    updateFavicon(orgAppearance.favicon || null);
  }, [orgAppearance.favicon]);

  useEffect(() => {
    const checkCmAccess = async () => {
      if (!authToken) {
        setHasCmAccess(false);
        return;
      }

      try {
        const response = await axios.get(
          `${environment.organizationSettingsApi}${appUrls.cmAccessAPIs.hasCmAccess}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`
            }
          }
        );
        if (response.data && response.data.hasAccess) {
          setHasCmAccess(response.data.hasAccess);
        } else {
          setHasCmAccess(false);
        }
      } catch (error) {
        console.error("Error checking CM access:", error);
        setHasCmAccess(false);
      }
    };

    checkCmAccess();
  }, [authToken]);

  useEffect(() => {
    const checkAccess = async () => {
      if (!authToken) {
        return;
      }

      try {
        const response = await axios.get(
          `${environment.organizationSettingsApi}${appUrls.cmAccessAPIs.hasAccess}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`
            }
          }
        );

        if (response.data && response.data.hasDriveAccess) {
          setHasDriveAccess(response.data.hasDriveAccess);
        }

        if (response.data && response.data.hasChatAccess) {
          setHasChatAccess(response.data.hasChatAccess);
        }
      } catch (error) {
        console.error("Error checking Drive access:", error);
      }
    };

    checkAccess();
  }, [authToken]);

  useEffect(() => {
    if (!authUser?.user?.ID) return;
  
    let cancelled = false;
  
    (async () => {
      try {
        const userPlanRes = await getCurrentUserPlan();
        const name = parsePlanNameFromUserPlanResponse(userPlanRes) ?? "Free";
        if (cancelled) return;
        setPlanLabel(name);
  
        const searchRes = await getPlanSearchByName(name);
        const mins = parseMeetingLengthMinutesFromPlanSearchResponse(searchRes);
        if (!cancelled) {
          setMeetingDurationMinutes(mins);
        }
      } catch {
        if (!cancelled) {
          setPlanLabel("Free");
          setMeetingDurationMinutes(null);
        }
      }
    })();
  
    return () => {
      cancelled = true;
    };
  }, [authUser?.user?.ID]);
  const normalizedPlan = planLabel.trim().toLowerCase();
  const isBusinessPlan = normalizedPlan === "business";
  const isFreePlan = normalizedPlan === "free";
  const isProPlan = normalizedPlan === "pro";
  const isEduPlan = normalizedPlan === "edu starter";
  const isUser = role === RoleType.User;
  const showUpgradeCta = !isUser && isFreePlan;
  const displayMeetingDurationMinutes =
    meetingDurationMinutes ??
    (isFreePlan ? FREE_PLAN_MEETING_DURATION_FALLBACK_MINUTES : null);
  const showUpgradePrompt =
    !isBusinessPlan && (showUpgradeCta || isFreePlan);

  const showUpgradePlanCard = !environment.hidePlanUpgradeCard;
  const showFeedbackMenu = !environment.hideFeedbackMenu;

  const getUpgradePlanUrl = () => {
    try {
      const url = new URL(`${environment.cmFrontendUrl}/login-subscription`);
      url.searchParams.set("jwt", authToken ?? "");
      return url.toString();
    } catch (error) {
      console.error("Upgrade plan URL build failed:", error);
      return `${environment.cmFrontendUrl}/login-subscription?jwt=${authToken}`;
    }
  };

  // The organization font is applied to the document root, so the sidebar inherits it like
  // everything else. This used to be the only place in the app that received it.
  const sidebarStyle = {
    fontFamily: 'var(--app-font-stack)'
  };

    return (
        <>
            <span
                style={
                    mobileMenu || isMobile
                        ? {display: "none"}
                        : {display: "block"}
                }

                onClick={setMobileMenuChange} className="hamburgerIcon"><HamburgerIcon/></span>
            <div
                className={isCollapse ? "cnv-left-sidebar cnv-left-sidebar-collapse" : "cnv-left-sidebar"}
                style={sidebarStyle}
            >

                <span onClick={setMobileMenuChange} className="clossMobileMenu"><Cross/></span>

                <span
                    onClick={setIsCollapseChange}
                    className="menu-collapse-arrow"><MenuCollapseIcon/></span>

                <div className={mobileMenu ? "overflow_hidden cnv-hasMobileMenu" : "overflow_hidden"}>

                    <div className="cnv-org-name">

                        <Link to="/home">

                            {(orgAppearance.logoUrl) ? (
                                <img
                                    src={
                                      `${environment.fileServiceApi}${orgAppearance.logoUrl.startsWith('file/') ? '' : 'file/'}${orgAppearance.logoUrl}`
                                    }
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                    onError={(e) => {
                                      e.currentTarget.style.display = 'none';
                                    }}
                                />
                            ) : orgAppearance.organizationName ? (
                                <>
                                  <span className="cnv-org-name-icon">
                                      {!secondOrgWord ? firstOrgWord : firstOrgWord + secondOrgWord}
                                  </span>
                                  <span className="company-name">{orgAppearance.organizationName}</span>
                                </>
                            ) : null}
                        </Link>
                    </div>

          <div className={`cnv-left-sidebar-container ${styles.sidebarMenuContainer}`}>
            <ul className={styles.sidebarMenuList}>
              <li
                onClick={() => setChatClass(false)}
                className={setActiveClass("/home")}
                style={
                  authUser?.permission.view_dashboard
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <Link to="/home" className="cnv-link home-link" onClick={() => dispatch(setMatrixState(false))}>
                  <HomeIcon />
                  <span>{t("home")}</span>
                </Link>
              </li>
              <li
                onClick={() => setChatClass(false)}
                className={setActiveClass("/meeting-management")}
                style={
                  authUser?.permission.view_meeting
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <Link
                  to="/meeting-management"
                  className="cnv-link"
                  data-testid={"meeting-management"}
                  onClick={() => dispatch(setMatrixState(false))}
                >
                  <MeetingIcon />
                  <span>{t("meeting_management")}</span>
                </Link>
              </li>
              {_allowInPersonMeeting && (
              <li
                onClick={() => setChatClass(false)}
                className={setActiveClass("/inperson-meeting")}
                style={
                  authUser?.permission.view_meeting
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <Link
                  to="/inperson-meeting"
                  className="cnv-link"
                  data-testid={"inperson-meeting"}
                  onClick={() => dispatch(setMatrixState(false))}
                >
                  <Person />
                  <span>{t("inperson_meeting")}</span>
                </Link>
              </li> )}
              {/* {shouldDisplayMatrixChat && authObject?.matrixAccessToken && (
                <li onClick={() => setChatClass(!chatClass)} className={chatClass ? "cnv-active" : ""}>
                  <Link to={history.location.pathname} className="cnv-link" onClick={() => dispatch(setMatrixState(!chatClass))}>
                    <ChatIcon />
                    <span>{t("chat")}</span>
                  </Link>
                </li>
              )} */}
              {hasChatAccess && authObject?.matrixAccessToken && (
                <li className={chatClass ? "cnv-active" : ""}>
                  <a
                    id="sidebar-chat-link"
                    href={`${environment.elementFrontendUrl}#/jwt=${authToken}/userId=${authUser?.user?.ID}`}
                    className="cnv-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className={styles.cnvLinkContent}>
                      <ChatIcon />
                      <span>{t("chat")}</span>

                      {activeCalls.length > 0 && (
                        <div className={styles.incomingCallContainer}>
                          <img src="images/phone.svg" alt="" />
                          <span className={styles.incomingCall}>
                          Incoming call {/* ({activeCalls.length}) */}
                        </span>
                        </div>
                      )}
                    </div>
                  </a>
                </li>
              )}
              {hasDriveAccess && <li className={setActiveClass("/cloud")}>
                  <a id="sidebar-drive-link" href={`${environment.driveFeatureUrl}?username=${authUser?.user.user_email}`+`&token=${authToken}`} target="_blank" className="cnv-link">
                  <FileIcon />
                  <span>{t("convay_drive", { appName })}</span>
                </a>
              </li>}
              {hasCmAccess && environment.showCM && (
                <li>
                  <a
                    id="sidebar-admin-settings-link"
                    data-testid="sidebar-admin-settings-link"
                    href={`${environment.cmFrontendUrl}/login?jwt=${authToken}`}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="cnv-link"
                  >
                    <AdminSetting />
                    <span>{t("admin_settings")}</span>{" "}
                  </a>
                </li>
              )}


              {/*
                <li
                onClick={() => setChatClass(false)}
                className={
                  hasSubMenu ? "cnv-submenu cnv-hasSubmenu" : "cnv-submenu"
                }
                style={
                  role === RoleType.Owner || role === RoleType.Admin
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <span className="submenu-label" onClick={setHasSubMenuChange}>
                  <AdminSetting />
                  <span>{t("admin_settings")}</span>
                  <span className="submenu-arrow">
                    <SubMenuDownArrow />
                  </span>
                </span>
                <ul>
                  <li
                    className={setActiveClass("/user-management")}
                    style={
                      role === RoleType.Owner || role === RoleType.Admin
                        ? { display: "block" }
                        : { display: "none" }
                    }
                    onClick={() => setChatClass(false)}
                  >
                    <Link to={`/user-management`} className="cnv-link" onClick={() => dispatch(setMatrixState(false))}>
                      <span>{t("manage_users")}</span>
                    </Link>
                  </li>

                  <li
                    className={setActiveClass("/organization")}
                    style={
                      role === RoleType.Owner
                          ? {display: "block"}
                          : {display: "none"}
                    }
                    onClick={() => setChatClass(false)}
                  >
                    <Link to={`/organization`} className="cnv-link" onClick={() => dispatch(setMatrixState(false))}>
                      <span>{t("manage_organization")}</span>
                    </Link>
                  </li>

                  { <li
                    className={setActiveClass("/organization")}
                    style={
                      authUser?.permission.view_organization
                        ? { display: "block" }
                        : { display: "none" }
                    }
                    onClick={() => setChatClass(false)}
                  >
                    <Link to={`/organization`} className="cnv-link" onClick={() => dispatch(setMatrixState(false))}>
                      <span>{t("manage_organization")}</span>
                    </Link>
                  </li> 
                 }
                </ul>
              </li>  */}
              
            </ul>
            <div className={styles.sidebarContainer}>

              {showFeedbackMenu && (
                <div className={styles.feedbackEntryContainer}>
                  <button
                    type="button"
                    className={styles.feedbackEntryButton}
                    onClick={() => setIsFeedbackModalOpen(true)}
                  >
                    <img src="/images/feedback-icon.svg" alt="Feedback" />
                    <span>{t("give_feedback")}</span>
                  </button>
                </div>
              )}

              {!isCollapse && showUpgradePlanCard && (
                <div
                  className={`${styles.upgradePlanContainer} ${showUpgradeCta ? styles.upgradePlanContainerOwner : styles.upgradePlanContainerUser}`}
                >
                  <div className={styles.upgradePlanTextGroup}>
                  <p className={styles.currentPlanLabel}>
                    {t("upgrade_card_plan_label", { plan: planLabel })}
                  </p>
                  {displayMeetingDurationMinutes != null && (
                    <p className={styles.currentPlanMeta}>
                      {!isUser ? 
                        (getOwnerUpgradeCardMeta(t as (key: string, opts?: Record<string, unknown>) => string, displayMeetingDurationMinutes, isFreePlan, isProPlan, isEduPlan))
                        :
                        (getUserUpgradeCardMeta(t as (key: string, opts?: Record<string, unknown>) => string, displayMeetingDurationMinutes, isFreePlan, isProPlan, isEduPlan)) }
                    </p>
                  )}
                  </div>
                  {showUpgradeCta && (
                    <a
                      className={styles.upgradePlanButton}
                      href={getUpgradePlanUrl()}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("upgrade_card_cta_upgrade_plan")}
                      <span className={styles.upgradePlanIcon} aria-hidden="true">
                        <UpgradeDiamondIcon />
                      </span>
                    </a>
                  )}
                </div>
              )}
              
            </div>
            
          </div>
        </div>
      </div>
      {showFeedbackMenu && (
        <SidebarFeedbackModal
          isOpen={isFeedbackModalOpen}
          onClose={() => setIsFeedbackModalOpen(false)}
        />
      )}
    </>
  );
}
